export const state = {
    PRICEFEED_DATA:[],
    IsinsList:[],
    socketConnected: {},
    getSubscriptionDetail: {},
    zuluAccountList: {},
    ibMamPammAccountList: {},
    entityData: '',

    hoopsData: {},
    allAccountList: {},

    formDisplayVar: '',

    VIDEO_TUTORIAL: [],

    //=========================================================================================================================================
    referList: [],
    currentNews: {},
    currentNewsDetails: {},
    autoChartist: [],
    signalCentre: [],
    subPlanList: [],
    sunPlanDetail: [],
    economicCalData: [],
    vpsList: {},
    vpsDetail: [],

    tradingAccountList: [],
    accountDetails: [],
    countriesList: [],
    citiesList: [],
    depositList: [],
    withdrawalList: [],
    bonusList: [],
    lastSelectTradingAccount: [],
    ticketList: [],
    ticketView: [],
    bankList: [],
    userProfile: [],
    userNotify: [],
    ticketData: [],
    walletAccount: {},
    walletTransaction: {},
    walletCurrencyData: [],
    walletBalnce: {},

    loyalityCardDetail: [],
    loyalityCardTxn: {},
    loyalityLastCredit: {},
    notificationList: { 'totalRecords': 0, 'records': [] },
    notificationUnreadList: { 'totalRecords': 0, 'records': [] },
    //====================static state variable list=======================
    empStatus: { '01': 'Employed', '02': 'Self-Employed', '03': 'Unemployed', '04': 'Retired' },
    occupation: { "1": "accountancy", "2": "admin_secretarial", "3": "auctions", "4": "catering_hospitality", "5": "creative_media", "6": "education", "7": "emergency_services", "8": "engineering", "9": "financial_services", "10": "gas_petrol", "11": "health_medicine", "12": "army_industry", "13": "hr", "14": "insurance ", "15": "legal", "16": "leisure_tourism", "17": "manufacturing", "18": "marketing_pr_advertising", "19": "pharmaceuticals", "20": "precious_metals_Diamonds", "21": "property_construction_real_state", "22": "retail", "23": "sales", "24": "social_care_services", "25": "telecommunications", "26": "transport_logistics", "27": "trust_charities_foundations", "28": "virtual_currency", "29": "other_please_specify" },
    estYearlyIncome: { '01': 'till_ten_thousand', '02': 'till_fifty_thousand', '03': 'till_one_lac', '04': 'till_two_lac', '05': 'above_two_lac' },
    estNetWorth: { '01': 'till_fiftythousand', '02': 'till_one_lac', '03': 'till_three_lac', '04': 'above_three_lac' },
    antAccountTurnover: { '01': '€0 - €10k', '02': '€10k - €50k', '03': '€50k -€100k', '04': '€100k - €250k', '05': '€250k - €500k', '06': '€500k +' },
    source_of_fund: { '01': 'employment', '02': 'inheritance', '03': 'investment', '04': 'real_estate', '05': 'savings', '06': 'other' },
    // education: { '01': 'University College', '02': 'Secondary Education', '03': 'Primary Education', '04': 'No Education',},
    // empStatus: { '01': 'Employed', '02': 'Self-Employed', '03': 'Unemployed', '04': 'Student', '05': 'Retired' },
    // occupation: { "1": "accountancy", "2": "admin_secretarial", "3": "auctions", "4": "catering_hospitality", "5": "creative_media", "6": "education", "7": "emergency_services", "8": "engineering", "9": "financial_services", "10": "gas_petrol", "11": "health_medicine", "12": "army_industry", "13": "hr", "14": "insurance", "15": "legal", "16": "leisure_tourism", "17": "manufacturing", "18": "marketing_pr_advertising", "19": "pharmaceuticals", "20": "precious_metals_Diamonds", "21": "property_construction_real_state", "22": "retail", "23": "sales", "24": "social_care_services", "25": "telecommunications", "26": "transport_logistics", "27": "trust_charities_foundations", "28": "virtual_currency", "29": "other_please_specify" },
    // estYearlyIncome: { '01': 'till_ten_thousand', '02': 'till_fifty_thousand', '03': 'till_one_lac', '04': 'till_two_lac', '05': 'above_two_lac' },
    // estNetWorth: { '01': 'zero_fiftythousand', '02': 'till_fiftythousand', '03': 'till_three_lac', '04': 'above_three_lac' },
    // antAccountTurnover: { '01': '€0 - €10k', '02': '€10k - €50k', '03': '€50k -€100k', '04': '€100k - €250k', '05': '€250k - €500k', '06': '€500k +' },
    // source_of_fund: { '01': 'employment', '02': 'inheritance', '03': 'investment', '04': 'real_estate', '05': 'savings', '06': 'other' },

    selectTinPassport: {},


    withdrawalMethodResponse: {},
    withdrawalMethodResponseDep: {},

    //deposit
    deposit_limit: [],
    depositStatus: { '0': 'pending', '1': 'success', '3': "Declined", '4': "From unverified account" }, //not use

    couponlist: [],
    //tradinAccount
    demoAccountList: [],
    liveAccountList: [],


    ticketReasonList: [],
    CRSNUMBER: { "UY": "Single Register of Tax Payers Number (RUT) OR ID card", "US": "Social Security Number (SSN) OR Employer Identification Number (EIN) OR Individual Taxpayer Identification Number (ITIN)", "GB": "unique taxpayer reference (UTR) AND National Insurance Number (NINO).", "AE": "N/A", "TC": "N/A", "TR": "National Identity Number ", "TT": "BIR number", "BS": "N/A", "CH": "UID-number", "SE": "Personal identity number/personnummer", "ES": "DNI Number / Numero de Identificacion Fiscal", "ZA": "Taxpayer reference number", "SI": "SI tax number", "SK": "Personal number (Rodn� _�slo)", "SG": "NRIC Number OR FIN", "SC": "Tax Identification Number", "SA": "Tax Identification Number", "SM": "Social Security Number (SSI Number)", "WS": "Tax Payer Identification Number", "VC": "Tax Identification Number", "LC": "TIN", "RU": "Taxpayer Personal Identification Number (INN)", "RO": "National Identification Number (Cod Numeric Personal)", "PT": "Tax number (N�mero de Identifica��o Fiscal)", "PL": "National Identification Number (PESEL)", "NO": "Identity Number or D-Number", "NZ": "IRD Number", "AN": "TIN", "NR": "Nauru Integrated Tax System / NITS", "MS": "N/A", "MX": "Clave en el Registro Federal de Contribuyentes / RFC", "MU": "Tax Account Number", "MH": "Employer/e Identification Number OR Social Security Number", "MT": "National Identification Number", "MY": "Income tax Number/Nombor Cukai Pendapatan", "MO": "ID Number", "LU": "National identification Number (TIN-like)", "LT": "Personal code (Asmens kodas)", "LI": "Personenidentifikationsnummer (PEID Nummer)", "LB": "TIN", "LV": "Personal code (Personas kods)", "KW": "Civil Identification Number", "KR": "Resident Registration Number", "JE": "Social Security Number", "JP": "Individual Number", "IT": "Fiscal code (Codice fiscale)", "IL": "ID Number", "IM": "Tax Reference Numbers", "IE": "Personal Public Service Number (PPS No)", "ID": "Nomor Pokok Wajib Pajak (NPWP)", "IN": "PAN", "IS": "Icelandic Identification Number (kennitala)", "HU": "Ad�azonos�t� Jel", "HK": "Hong Kong Identity Card (HKID) number", "GG": "Social Insurance number", "GL": "CPR number", "GR": "TIN (_._.M.)", "GI": "N/A", "DE": "Steueridentifikationsnummer", "GE": "National Identification Number", "FR": "Num�ro Fiscal de R�f�rence", "FI": "Personal identity number", "FO": "Faroese P Number", "EE": "\"Estonian Personal Identification Code(Isikukood)\"", "EC": "Numero de Identificaci�n Fiscal (NIF)", "DK": "CPR number", "CZ": "National identification number (Rodn� _�slo)", "CY": "TIN (_._._.)", "CW": "Persoonsnummer", "HR": "\"Personal Identification Number(OIB � Osobni identifikacijski broj)\"", "CR": "N�mero de Indetificaci�n Tributario Especial (NITE)", "CK": "N/A", "CO": "N.I.T ", "CN": "ID Number", "CL": "National Identity Number (RUN)", "KY": "N/A", "CA": "Social Insurance Number (SIN)", "BG": "Personal Number", "BN": "N/A", "BR": "Cadastro de Pessoas F�sicas � CPF", "BM": "N/A", "BZ": "TIN", "BE": "Num�ro National (NN)", "BH": "N/A", "AZ": "VOEN", "AT": "Steuernummer", "AU": "Australian Tax File Number (TFN)", "AW": "Persoonsnummer", "AR": "C.U.I.T - Clave �nica de Identificaci�n Tributaria", "AD": "\"N�mero de Registre Tributari (NRT, Tax Register Number)\"" },

    european_countries_list: {
        "AT": "Austria",
        "BG": "Bulgaria",
        "HR": "Croatia",
        "CZ": "Czech Republic",
        "DK": "Denmark",
        "EE": "Estonia",
        "FI": "Finland",
        "FR": "France",
        "DE": "Germany",
        "GR": "Greece",
        "HU": "Hungary",
        "IS": "Iceland",
        "IE": "Ireland",
        "IT": "Italy",
        "LV": "Latvia",
        "LI": "Liechtenstein",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "MT": "Malta",
        "NL": "Netherlands",
        "NO": "Norway",
        "PL": "Poland",
        "PT": "Portugal",
        "RO": "Romania",
        "SK": "Slovakia",
        "SI": "Slovenia",
        "ES": "Spain",
        "SE": "Sweden",
        //"GB" :  "United Kingdom"
    },
    country_tax_residence_nationality: {
        "AT": { 'id': 15, 'name': "Austria", 'iso2': "AT" },
        "BG": { 'id': 34, 'name': "Bulgaria", 'iso2': "BG" },
        "HR": { 'id': 55, 'name': "Croatia", 'iso2': "HR" },
        "CZ": { 'id': 58, 'name': "Czech Republic", 'iso2': "CZ" },
        "DK": { 'id': 59, 'name': "Denmark", 'iso2': "DK" },
        "EE": { 'id': 69, 'name': "Estonia", 'iso2': "EE" },
        "FI": { 'id': 74, 'name': "Finland", 'iso2': "FI" },
        "FR": { 'id': 75, 'name': "France", 'iso2': "FR" },
        "DE": { 'id': 82, 'name': "Germany", 'iso2': "DE" },
        "GR": { 'id': 85, 'name': "Greece", 'iso2': "GR" },
        "HU": { 'id': 99, 'name': "Hungary", 'iso2': "HU" },
        "IS": { 'id': 100, 'name': "Iceland", 'iso2': "IS" },
        "IE": { 'id': 105, 'name': "Ireland", 'iso2': "IE" },
        "IT": { 'id': 107, 'name': "Italy", 'iso2': "IT" },
        "LV": { 'id': 120, 'name': "Latvia", 'iso2': "LV" },
        "LI": { 'id': 125, 'name': "Liechtenstein", 'iso2': "LI" },
        "LT": { 'id': 126, 'name': "Lithuania", 'iso2': "LT" },
        "LU": { 'id': 127, 'name': "Luxembourg", 'iso2': "LU" },
        "MT": { 'id': 135, 'name': "Malta", 'iso2': "MT" },
        "NL": { 'id': 156, 'name': "Netherlands", 'iso2': "NL" },
        "NO": { 'id': 165, 'name': "Norway", 'iso2': "NO" },
        "PL": { 'id': 176, 'name': "Poland", 'iso2': "PL" },
        "PT": { 'id': 177, 'name': "Portugal", 'iso2': "PT" },
        "RO": { 'id': 181, 'name': "Romania", 'iso2': "RO" },
        "SK": { 'id': 200, 'name': "Slovakia", 'iso2': "SK" },
        "SI": { 'id': 201, 'name': "Slovenia", 'iso2': "SI" },
        "ES": { 'id': 207, 'name': "Spain", 'iso2': "ES" },
        "SE": { 'id': 213, 'name': "Sweden", 'iso2': "SE" },
        "GB": { 'id': 232, 'name': "United Kingdom", 'iso2': "GB" }
    },
    nuveiData: {},
    vtpCountryCurrency: {
        ID: 'IDR',
        MY: 'MYR',
        VN: 'VND',
        TH: 'THB',
        KH: 'USD',
    },
    getVertupayList: {
        IDR: [
            {id: "BCA", value: "Bank Central Asia", pay_method: 'IB' },
            {id: "BNI", value: "Bank Negara Indonesia" , pay_method: 'IB'},
            // {id: "BRI", value: "Bank Rakyat Indonesia" , pay_method: 'IB' },
            // {id: "MDR", value: "Bank Mandiri", pay_method: 'IB'},

            {id: "BCA", value: "Bank Central Asia", pay_method: 'VA' },
            {id: "BNI", value: "Bank Negara Indonesia" , pay_method: 'VA'},
            {id: "BDM", value: "Bank Danamon", pay_method: 'VA' },
            {id: "BRI", value: "Bank Rakyat Indonesia" , pay_method: 'VA' },
            {id: "CIMB", value: "Bank CIMB (CIMB)" , pay_method: 'VA' },
            {id: "MDR", value: "Bank Mandiri" , pay_method: 'VA' },
            {id: "BSI", value: "Bank Syariah Indonesia" , pay_method: 'VA' },
            {id: "PRMT", value: "Bank Permata" , pay_method: 'VA' },
            // {id: "BSM", value: "Bank Sinarmas" , pay_method: 'VA' },
            // {id: "BSS", value: "Bank Sahabat Sampoerna" , pay_method: 'VA' },
            // {id: "MYB", value: "Maybank" , pay_method: 'VA' },

            {id: "QRIS", value: "QRIS" , pay_method: 'QR' },
        ],
        MYR: [
            // {id: "AMB", value: "Ambank", pay_method: 'IB' },
            // {id: "BIM", value: "Bank Islam Malaysia" , pay_method: 'IB'},
            // {id: "CIMB", value: "CIMB" , pay_method: 'IB' },
            // {id: "HLB", value: "Hong Leong Bank", pay_method: 'IB'},
            // {id: "MYB", value: "Maybank", pay_method: 'IB'},
            // {id: "PBB", value: "Public Bank", pay_method: 'IB'},
            // {id: "RHB", value: "RHB Bank", pay_method: 'IB'},

            {id: "AFB", value: "Affin Bank Berhad", pay_method: 'FPX'},
            {id: "ALB", value: "Alliance Bank", pay_method: 'FPX'},
            {id: "AMB", value: "Ambank", pay_method: 'FPX'},
            {id: "BKR", value: "Bank Rakyat", pay_method: 'FPX'},
            {id: "BSN", value: "Bank Simpanan National", pay_method: 'FPX'},
            {id: "BIM", value: "Bank Islam Malaysia", pay_method: 'FPX'},
            {id: "CIMB", value: "CIMB", pay_method: 'FPX'},
            {id: "HLB", value: "Hong Leong Bank", pay_method: 'FPX'},
            {id: "HSBC", value: "HSBC", pay_method: 'FPX'},
            {id: "MYB", value: "Maybank", pay_method: 'FPX'},
            {id: "OCBC", value: "OCBC", pay_method: 'FPX'},
            {id: "PBB", value: "Public Bank", pay_method: 'FPX'},
            {id: "RHB", value: "RHB Bank", pay_method: 'FPX'},
            {id: "SDCB", value: "Standard Chartered Bank", pay_method: 'FPX'},
            {id: "UOB", value: "United Overseas Bank", pay_method: 'FPX'},

            // {id: "DUITNOW", value: "DuitNow ", pay_method: 'QR'},
            
        ],
        VND: [
            {id: "ACB", value: "Asia Commercial Joint Stock Bank", pay_method: 'IB'},
            {id: "BIDV", value: "Bank for Investment and Development of Vietnam ", pay_method: 'IB'},
            {id: "DAB", value: "Dong A Bank", pay_method: 'IB'},
            {id: "TECHCOMBANK", value: "Technological and Commercial Joint Stock Bank", pay_method: 'IB'},
            {id: "VIETCOMBANK", value: "Joint Stock Commercial Bank for Foreign Trade of Vietnam ", pay_method: 'IB'},
            {id: "VIETINBANK", value: "Vietnam Joint Stock Commercial Bank for Industry and Trade", pay_method: 'IB'},

            {id: "VNDQR", value: "All majority banks in Vietnam", pay_method: 'QR'},

            // {id: "AGRI", value: "AGRI Bank ", pay_method: 'IB'},
            // {id: "EXM", value: "Exim Bank ", pay_method: 'IB'},
            // {id: "HDB", value: "HD Bank", pay_method: 'IB'},
            // {id: "MBB", value: "Military Commercial Joint Stock Bank ", pay_method: 'IB'},
            // {id: "SCB", value: "Sacombank ", pay_method: 'IB'},
            // {id: "SHB", value: "Saigon Hanoi Bank ", pay_method: 'IB'},
            // {id: "TPB", value: "Tien Phong Bank ", pay_method: 'IB'},
            // {id: "VCB", value: "Vietcom Bank ", pay_method: 'IB'},
            // {id: "VPB", value: "Vietnam Prosperity Joint Stock Commercial Bank", pay_method: 'IB'},
            // {id: "VTN", value: "Vietin Bank ", pay_method: 'IB'}
        ],
        THB: [
            // {id: "BAY", value: "Krungsri Bank", pay_method: 'IB'},
            // {id: "BKK", value: "Bangkok Bank", pay_method: 'IB'},
            // {id: "GSB", value: "Government Saving Bank", pay_method: 'IB'},
            // {id: "KBA", value: "Kasikornbank", pay_method: 'IB'},
            // {id: "KTB", value: "Krung Thai Bank", pay_method: 'IB'},
            // {id: "SIAM", value: "Siam Commercial Bank", pay_method: 'IB'},
            // {id: "TTB", value: "TMB Thanacart Bank", pay_method: 'IB'},

            {id: "THQR", value: "All banks in Thailand support QR Promptpay", pay_method: 'QR'},
        ],
        USD: [
            {id: "ABA", value: "Advanced Bank of Asia", pay_method: 'FT'},
            {id: "ACLEDA", value: "ACLEDA Bank", pay_method: 'FT'},
            {id: "WING", value: "Wing Bank", pay_method: 'FT'},
        ],
    },
    vtpAmountLimit: {
        MYR: { minlength: 10, maxlength: 50000 },
        THB: { minlength: 100, maxlength: 500000 },
        IDR: { minlength: 50000, maxlength: 200000000 },
        VND: { minlength: 50000, maxlength: 300000000 },
        USD: { minlength: 5, maxlength: 15000 },
    },
    getHelp2PayBankList: {
        THB: [
            { id: "BBLLBT", value: "Bangkok Bank Local Bank Transfer" },
            { id: "BOALBT", value: "Bank of Ayudhya (Krungsri) Local Bank Transfer" },
            { id: "KKRLBT", value: "KASIKORN BANK Local Bank Transfer" },
            { id: "PPTP", value: "PromptPay" },
            { id: "SCBLBT", value: "Siam Commercial Bank Local Bank Transfer" },
            { id: "TMBLBT", value: "TMBThanachart Bank Local Bank Transfer" },
            { id: "TSTB", value: "THB Semi Deposit" },
            
            {id: "BBL", value: "Bangkok Bank"},
            {id: "BOA", value: "Bank of Ayudhya (Krungsri)"},
            {id: "KKR", value: "Karsikorn Bank (K-Bank)"},
            {id: "KNK", value: "Kiatnakin Bank"},
            {id: "KTB", value: "Krung Thai Bank"},
            {id: "SCB", value: "Siam Commercial Bank"},
            {id: "TMB", value: "TMBThanachart Bank(TTB)"},

            /*{ id: "CIMBT", value: "CIMB Thai" },*/

            /*{ id: "GSB", value: "Government Savings Bank" },
            { id: "GSB", value: "Government Savings Bank" },
            { id: "HSBCT", value: "HSBC Thailand" },
            { id: "ICBCT", value: "Industrial and Commercial Bank of China (Thai)" },
            { id: "TBank", value: "Thanachart Bank" },
            { id: "UOB", value: "UOB Thai" },*/
        ],
        MYR: [
            { id: "AFF", value: "Affin Bank" },
            { id: "ALB", value: "Alliance Bank Malaysia Berhad" },
            { id: "AMB", value: "AmBank Group" },
            { id: "BIMB", value: "Bank Islam Malaysia Berhad" },
            { id: "BSN", value: "Bank Simpanan Nasional" },
            { id: "CIMB", value: "CIMB Bank Berhad" },
            { id: "HLB", value: "Hong Leong Bank Berhad" },
            { id: "HSBC", value: "HSBC Bank (Malaysia) Berhad" },
            { id: "MBB", value: "Maybank Berhad" },
            { id: "OCBC", value: "OCBC Bank" },
            { id: "PBB", value: "Public Bank Berhad" },
            { id: "RHB", value: "RHB Bank Berhad" },
            { id: "UOB", value: "United Overseas Bank" },
            { id: "FPX", value: "FPX Bank Selection Page" },
            { id: "AFFFPX", value: "Affin Bank (FPX)" },
            { id: "AGROBFPX", value: "Agrobank (FPX)" },
            { id: "ALBFPX", value: "Alliance Bank (FPX)" },
            { id: "AMBFPX", value: "AmBank (FPX)" },
            { id: "BIMBFPX", value: "Bank Islam (FPX)"},
            { id: "BKRFPX", value: "Bank Rakyat (FPX)"},
            { id: "BMMBFPX", value: "Bank Muamalat (FPX)"},
            { id: "BOCMFPX", value: "Bank of China (FPX)"},
            { id: "BSNFPX", value: "BSN Bank (FPX)"},
            { id: "CIMBFPX", value: "CIMB Bank (FPX)"},
            { id: "HLBFPX", value: "Hong Leong Bank (FPX)"},
            { id: "HSBCFPX", value: "HSBC (FPX)"},
            { id: "KFHFPX", value: "Kuwait Finance House (FPX)"},
            { id: "MBBFPX", value: "Maybank (FPX)"},
            { id: "OCBCFPX", value: "OCBC (FPX)"},
            { id: "PBBFPX", value: "Public Bank (FPX)"},
            { id: "RHBFPX", value: "RHB Bank (FPX)"},
            { id: "SCTBFPX", value: "Standard Chartered Bank (FPX)"},
            { id: "UOBFPX", value: "UOB (FPX)"},

            /*{ id: "AGROB", value: "Agro Bank" },
            { id: "BKR", value: "Bank Rakyat" },
            { id: "CITI", value: "Citibank" },
            { id: "SCTB", value: "Standard Chartered Bank Malaysia Berhad" },*/
        ],
        IDR: [
            { id: "BCA", value: "Bank Central Asia" },
            { id: "BNI", value: "Bank Negara Indonesia" },
            { id: "BRI", value: "Bank Rakyat Indonesia" },
            { id: "CIMBN", value: "Bank CIMB Niaga" },
            { id: "MDR", value: "Bank Mandiri" },
            { id: "PMTB", value: "Permata Bank" },
            { id: "PANIN", value: "Panin Bank" },
            { id: "QRIS", value: "QRIS" },
            // {id:"AFF"	,value:"Affin Bank"},
            // {id:"ALB"	,value:"Alliance Bank Malaysia Berhad"},
            // {id:"AMB"	,value:"AmBank Group"},
            // {id:"BIMB"	,value:"Bank Islam Malaysia Berhad"},
            // {id:"BSN"	,value:"Bank Simpanan Nasional"},
            // {id:"CIMB"	,value:"CIMB Bank Berhad"},
            // {id:"HLB"	,value:"Hong Leong Bank Berhad"},
            // {id:"HSBC"	,value:"HSBC Bank (Malaysia) Berhad"},
            // {id:"MBB"	,value:"Maybank Berhad"},
            // {id:"OCBC"	,value:"OCBC Bank"},
            // {id:"PBB"	,value:"Public Bank Berhad"},
            // {id:"RHB"	,value:"RHB Banking Group"},
            // {id:"UOB"	,value:"United Overseas Bank (Malaysia) Bhd"},
            // {id:"FPX"	,value:"FPX Bank Selection Page"},
            // {id:"AFFFPX"	,value:"Affin Bank (FPX)"},
            // {id:"AGROBFPX"	,value:"Agrobank (FPX)"},
            // {id:"ALBFPX"	,value:"Alliance Bank (FPX)"},
            // {id:"AMBFPX"	,value:"AmBank (FPX)"},
            // {id:"BIMBFPX"	,value:"Bank Islam (FPX)"},
            // {id:"BKRFPX"	,value:"Bank Rakyat (FPX)"},
            // {id:"BMMBFPX"	,value:"Bank Muamalat (FPX)"},
            // {id:"BOCMFPX"	,value:"Bank of China (FPX)"},
            // {id:"BSNFPX"	,value:"BSN Bank (FPX)"},
            // {id:"CIMBFPX"	,value:"CIMB Bank (FPX)"},
            // {id:"HLBFPX"	,value:"Hong Leong Bank (FPX)"},
            // {id:"HSBCFPX"	,value:"HSBC (FPX)"},
            // {id:"KFHFPX"	,value:"Kuwait Finance House (FPX)"},
            // {id:"MBBFPX"	,value:"Maybank (FPX)"},
            // {id:"OCBCFPX"	,value:"OCBC (FPX)"},
            // {id:"PBBFPX"	,value:"Public Bank (FPX)"},
            // {id:"RHBFPX"	,value:"RHB Bank (FPX)"},
            // {id:"SCTBFPX"	,value:"Standard Chartered Bank (FPX)"},
            // {id:"UOBFPX"	,value:"UOB (FPX)"},
            // {id:"BBL"	,value:"Bangkok Bank"},
            // {id:"BOA"	,value:"Bank of Ayudhya (Krungsri)"},
            // {id:"KKR"	,value:"Karsikorn Bank (K-Bank)"},
            // {id:"KNK"	,value:"Kiatnakin Bank"},
            // {id:"KTB"	,value:"Krung Thai Bank"},
            // {id:"SCB"	,value:"Siam Commercial Bank"},
            // {id:"TMB"	,value:"TMBThanachart Bank(TTB)"},
            // {id:"ACB"	,value:"Asia Commercial Bank"},
            // {id:"AGB"	,value:"Agribank"},
            // {id:"BIDV"	,value:"Bank for Investment and Development of Vietnam"},
            // {id:"DAB"	,value:"DongA Bank"},
            // {id:"EXIM"	,value:"Eximbank Vietnam"},
            // {id:"HDB"	,value:"HDB Bank"},
            // {id:"MB"	,value:"Military Commercial Joint Stock Bank"},
            // {id:"MTMB"	,value:"Maritime Bank"},
            // {id:"OCB"	,value:"Orient Commercial Joint Stock Bank"},
            // {id:"SACOM"	,value:"Sacombank"},
            // {id:"TCB"	,value:"Techcombank"},
            // {id:"TPB"	,value:"Tien Phong Bank"},
            // {id:"VCB"	,value:"Vietcombank"},
            // {id:"VIB"	,value:"Vietnam International Bank"},
            // {id:"VPB"	,value:"VP Bank"},
            // {id:"VTB"	,value:"Vietinbank"},
            // {id:"BNI"	,value:"Bank Negara Indonesia"},
            // {id:"BRI"	,value:"Bank Rakyat Indonesia"},
            // {id:"CIMBN"	,value:"CIMB Niaga"},
            // {id:"MDR"	,value:"Mandiri Bank"},
            // {id:"PMTB"	,value:"Permata Bank"},
            // {id:"PANIN"	,value:"Panin Bank"},
            // {id:"BDO"	,value:"Banco de Oro"},
            // {id:"BPI"	,value:"Bank of the Philippine Islands"},
            // {id:"LBP"	,value:"Land Bank of the Philippines"},
            // {id:"RCBC"	,value:"Rizal Commercial Banking Corporation"},
            // {id:"SBC"	,value:"Security Bank Corporation"},
            // {id:"AXIS"	,value:"AXIS Bank"},
            // {id:"HDFC"	,value:"HDFC Bank"},
            // {id:"IDFC"	,value:"IDFC Bank"},
            // {id:"INDUSIND"	,value:"INDUSIND Bank"},
            // {id:"KOTAK"	,value:"KOTAK Mahindra Bank"},
            // {id:"YES"	,value:"YES Bank"},
            // {id:"CIUB"	,value:"CITY UNION"},
            // {id:"FEDERAL"	,value:"Federal Bank"},
            // {id:"IDIB"	,value:"INDIAN BANK"},
            // {id:"ICICI"	,value:"ICICI Bank Limited"},


            /*{ id: "BDI", value: "Bank Danamon Indonesia" },
            { id: "MBBI", value: "Bank Maybank Indonesia" },
            { id: "ISTB", value: "IDR Virtual Account" },*/

            /*{ id: "BCASB", value: "BCA Syariah Bank" },
            { id: "BMI", value: "Bank Mega Indonesia" },
            { id: "BRISB", value: "BRI Syariah Bank" },
            { id: "BSM", value: "Bank Sinarmas" },
            { id: "BTN", value: "Bank Tabungan Negara" },
            { id: "BTPN", value: "Bank Tabungan Pensiunan Nasional" },
            { id: "OCBCN", value: "Bank OCBC NISP" },*/
        ],
        VND: [
            { id: "ACB", value: "Asia Commercial Bank" },
            { id: "AGB", value: "Agribank" },
            { id: "BIDV", value: "Bank for Investment and Development of Vietnam" },
            { id: "DAB", value: "DongA Bank" },
            { id: "EXIM", value: "Eximbank" },
            { id: "HDB", value: "HD Bank" },
            { id: "MB", value: "Military Commercial Joint Stock Bank" },
            { id: "MTMB", value: "Maritime Bank" },
            { id: "OCB", value: "Orient Commercial Joint Stock Bank" },
            { id: "SACOM", value: "Sacom Bank" },
            { id: "TCB", value: "Techcombank" },
            { id: "TPB", value: "Tien Phong Bank" },
            { id: "VCB", value: "Vietcombank" },
            { id: "VIB", value: "Vietnam International Bank" },
            { id: "VPB", value: "VP Bank" },
            { id: "VTB", value: "VietinBank" },

            /*{ id: "MB ", value: "Military Commercial Joint Stock Bank" },*/
            /*{ id: "ABCJS", value: "An Binh Commercial Join Stock Bank" },
            { id: "BOCV", value: "Bank Of China Vietnam" },
            { id: "CITIV", value: "Citibank Vietnam" },
            { id: "HSBCV", value: "HSBC Vietnam" },
            { id: "NAMA", value: "Nam A Commercial Joint Stock Bank (NamaBank)" },
            { id: "PVCB", value: "PVcomBank" },
            { id: "SCBV", value: "Standard Chartered Bank Vietnam" },
            { id: "SCMB", value: "Saigon Bank" },
            { id: "SGCB", value: "Saigon Commercial Bank" },
            { id: "SHBV", value: "Shinhan Bank Vietnam" },
            { id: "SHCB", value: "Saigon-Hanoi Commercial Joint Stock Bank" },*/
        ],
        PHP: [
            { id: "BDO", value: "BANCO DE ORO" },
            { id: "BPI", value: "Bank of the Philippine Islands" },
            { id: "LBP", value: "Land Bank of the Philippines" },
            { id: "RCBC", value: "Rizal Commercial Banking Corporation" },
            { id: "SBC", value: "Security Bank Corporation" },
            /*{ id: "MTB", value: "Metropolitan Bank & Trust Company" },*/

            /*{ id: "UBP", value: "Union Bank of the Philippines" },
            { id: "MTB", value: "Metropolitan Bank & Trust Company" },
            { id: "PNB", value: "Philippine National Bank" },
            { id: "BDOE", value: "BANCO DE ORO Corporate" },*/

        ],
        INR: [
            { id: "AXIS", value: "AXIS Bank" },
            { id: "HDFC", value: "HDFC Bank" },
            { id: "IDFC", value: "IDFC Bank" },
            { id: "INDUSIND", value: "INDUSIND Bank" },
            { id: "KOTAK", value: "KOTAK Mahindra Bank" },
            { id: "YES", value: "YES Bank" },
            { id: "CIUB", value: "CITY UNION" },
            { id: "FEDERAL", value: "Federal Bank" },
            { id: "IDIB", value: "INDIAN BANK" },
            { id: "ICICI", value: "ICICI Bank Limited" },
        ],
    },
    countryCurrency: {
        VN: 'VND',
        ID: 'IDR',
        MY: 'MYR',
        PH: 'PHP',
        TH: 'THB',
    },
    amountLimit: {
        MYR: { minlength: 10, maxlength: 50000 },
        THB: { minlength: 100, maxlength: 500000 },
        IDR: { minlength: 50000, maxlength: 200000000 },
        VND: { minlength: 50000, maxlength: 300000000 },
        PHP: { minlength: 100, maxlength: 1000000 },
        USD: { minlength: 5, maxlength: 15000 },
    },
    astroPayCountryMethods: {
        BR: [
            { pay_method: 'Pix via Open Finance', code: 'I6', pay_type: 'BANKING', isAllow: false },
            { pay_method: 'Pix', code: 'IX', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Mercado Pago', code: 'WM', pay_type: 'WALLET', isAllow: false },
            { pay_method: 'Local Credit/Debit Card', code: 'EC', pay_type: 'CARD', isAllow: true },
            { pay_method: 'Boleto', code: 'BL', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Banco Brasil', code: 'BB', pay_type: 'BANKING', isAllow: false },
            { pay_method: 'Bradesco', code: 'B', pay_type: 'BANKING', isAllow: false },
            { pay_method: 'Itau', code: 'I', pay_type: 'BANKING', isAllow: false },
            { pay_method: 'Banco Safra', code: 'SF', pay_type: 'BANKING', isAllow: false },
            { pay_method: 'Banco Original', code: 'BZ', pay_type: 'BANKING', isAllow: false },
            { pay_method: 'Loterias Caixa', code: 'LC', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Banrisul', code: 'UL', pay_type: 'BANKING', isAllow: false },
            { pay_method: 'Neteller', code: 'NE', pay_type: 'WALLET', isAllow: false }
        ],
        AR: [
            { pay_method: 'Mercado Pago', code: 'WM', pay_type: 'WALLET', isAllow: false },
            { pay_method: 'Pago Fácil', code: 'PF', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'MODO', code: 'M0', pay_type: 'WALLET', isAllow: true },
            { pay_method: 'Local Credit/Debit Card', code: 'EC', pay_type: 'CARD', isAllow: true },
            { pay_method: 'Rapipago', code: 'RP', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Transferencia en Linea', code: 'E5', pay_type: 'BANKING', isAllow: false },
            { pay_method: 'Pago24', code: 'VP', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Telerecargas', code: 'RR', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Santander', code: 'SB', pay_type: 'BANKING', isAllow: false },
            { pay_method: 'BBVA', code: 'BF', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Banco Galicia', code: 'GL', pay_type: 'BANKING', isAllow: false }
        ],
        CL: [
            { pay_method: 'WebPay', code: 'WP', pay_type: 'CARD', isAllow: true },
            { pay_method: 'Local Credit/Debit Card', code: 'EC', pay_type: 'CARD', isAllow: true },
            { pay_method: 'Santander', code: 'SC', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Banco de Chile', code: 'BX', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Banco BCI', code: 'CI', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Itau', code: 'IA', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Banco Falabella', code: 'LL', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Caja Vecina', code: 'C2', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'A cuenta', code: 'A2', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Sencillito', code: 'S2', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Lider', code: 'LI', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Express Líder', code: 'E2', pay_type: 'CASH COLLECTION', isAllow: true }
        ],
        CO: [
            { pay_method: 'PSE', code: 'PC', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Nequi', code: 'NQ', pay_type: 'WALLET', isAllow: true },
            { pay_method: 'Efecty', code: 'EY', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Local Credit/Debit Card', code: 'EC', pay_type: 'CARD', isAllow: true },
            { pay_method: 'Bancolombia Transfer', code: 'BN', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Bancolombia Efectivo', code: 'B9', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Almacenes Exito', code: 'EX', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Punto Red', code: 'PD', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Super Pagos', code: '9S', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Su Red', code: 'RD', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Super inter', code: 'NR', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Gana Gana', code: 'GG', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Moviired', code: 'MV', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Su Chance', code: 'CX', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Carulla', code: 'CR', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Surtimax', code: 'SX', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Jer', code: 'JE', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Coopenessa', code: 'OO', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Fullcarga', code: 'FU', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Edeq', code: 'DQ', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Surti mayorista', code: 'YR', pay_type: 'CASH COLLECTION', isAllow: true }
        ],
        MX: [
            { pay_method: 'Spei', code: 'SE', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Local Credit/Debit Card', code: 'EC', pay_type: 'CARD', isAllow: true },
            { pay_method: 'OXXO', code: 'OX', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'ToditoCash', code: 'TC', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: '7 eleven', code: 'EN', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Santander', code: 'SC', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Walmart', code: 'WA', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Bodega Aurrera', code: 'BW', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Farmacias del ahorro', code: 'FA', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Walmart Express', code: 'W1', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Farmacia Benavides', code: 'FB', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Soriana', code: 'S3', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Kiosko', code: 'K1', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Circulo K', code: 'CU', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Farmacia Roma', code: 'F6', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Sams Club', code: 'SS', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Calimax', code: 'C4', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'HSBC', code: 'HS', pay_type: 'CASH COLLECTION', isAllow: false },
            { pay_method: 'Superama', code: 'SU', pay_type: 'CASH COLLECTION', isAllow: true }
        ],
        PY: [
            { pay_method: 'Visa', code: 'VI', pay_type: 'CARD', isAllow: true },
            { pay_method: 'Mastercard', code: 'MC', pay_type: 'CARD', isAllow: true }
        ],
        PE: [
            { pay_method: 'PagoEfectivo', code: 'EF', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Local Credit/Debit Card', code: 'EC', pay_type: 'CARD', isAllow: true },
            { pay_method: 'Tupay', code: '2P', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'BCP', code: 'BC', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'InterBank', code: 'IB', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Yape', code: 'YP', pay_type: 'WALLET', isAllow: false },
            { pay_method: 'PLIN', code: 'PR', pay_type: 'WALLET', isAllow: false },
            { pay_method: 'BBVA', code: 'BF', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'ScotiaBank', code: 'ST', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Tambo', code: 'MO', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Banco ripley', code: 'B2', pay_type: 'BANKING', isAllow: true },
            { pay_method: 'Caja Huancayo', code: 'HC', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Kasnet', code: 'KE', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Western Union', code: 'WU', pay_type: 'CASH COLLECTION', isAllow: true },
            { pay_method: 'Caja Arequipa', code: 'JA', pay_type: 'CASH COLLECTION', isAllow: true }
        ],
        GH: [
            { pay_method: 'MTN', code: 'MT', pay_type: 'MOBILE MONEY', isAllow: true },
            { pay_method: 'Airtel Money', code: 'AL', pay_type: 'MOBILE MONEY', isAllow: true },
            { pay_method: 'Vodafone', code: 'VO', pay_type: 'MOBILE MONEY', isAllow: true },
        ],
        KE: [
            { pay_method: 'M-Pesa', code: 'MP', pay_type: 'MOBILE MONEY', isAllow: true },
            { pay_method: 'Airtel Money', code: 'AL', pay_type: 'MOBILE MONEY', isAllow: false },
        ],
        TZ: [
            { pay_method: 'Airtel Money', code: 'AL', pay_type: 'MOBILE MONEY', isAllow: true },
            { pay_method: 'Tigo', code: 'TG', pay_type: 'MOBILE MONEY', isAllow: true },
        ],
    }
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/state.js